import { render, staticRenderFns } from "./subItem.vue?vue&type=template&id=6baac34f&scoped=true"
import script from "./subItem.vue?vue&type=script&lang=js"
export * from "./subItem.vue?vue&type=script&lang=js"
import style0 from "./subItem.vue?vue&type=style&index=0&id=6baac34f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baac34f",
  null
  
)

export default component.exports